module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-sidebar-inset-reverse-53d37690.svg";